// Parent/student subject pages (native /subject, /sallaybusSubjectOutline,
// /subjectOutline, /classWork, /subjectClasswork). Globally unique — the
// school-side subject/syllabus actions use unprefixed names.
export const SP_SUBJ_LIST = 'SP_SUBJ_LIST'
export const SP_SUBJ_DETAIL = 'SP_SUBJ_DETAIL'
export const SP_SUBJ_RESOURCES = 'SP_SUBJ_RESOURCES'
export const SP_SUBJ_CLASS_RESOURCES = 'SP_SUBJ_CLASS_RESOURCES'
export const SP_SUBJ_OUTLINE = 'SP_SUBJ_OUTLINE'
export const SP_SUBJ_OUTLINE_SCHEDULE = 'SP_SUBJ_OUTLINE_SCHEDULE'
export const SP_SUBJ_OUTLINE_WEEKLY = 'SP_SUBJ_OUTLINE_WEEKLY'
export const SP_SUBJ_LEGACY_OUTLINES = 'SP_SUBJ_LEGACY_OUTLINES'
export const SP_SUBJ_LEGACY_OUTLINE = 'SP_SUBJ_LEGACY_OUTLINE'
export const SP_SUBJ_CLASS_WORK = 'SP_SUBJ_CLASS_WORK'
export const SP_SUBJ_SUBJECT_CLASSWORK = 'SP_SUBJ_SUBJECT_CLASSWORK'
export const SP_SUBJ_SUBJECT_CLASSWORK_DETAIL = 'SP_SUBJ_SUBJECT_CLASSWORK_DETAIL'
// lecture inquiry (the mobile lecture chat) and the family schedule lists
export const SP_SUBJ_LECTURE_INQUIRY = 'SP_SUBJ_LECTURE_INQUIRY'
export const SP_SUBJ_LECTURE_INQUIRY_SEND = 'SP_SUBJ_LECTURE_INQUIRY_SEND'
export const SP_SUBJ_DAILY_SCHEDULES = 'SP_SUBJ_DAILY_SCHEDULES'
export const SP_SUBJ_YEARLY_SCHEDULES = 'SP_SUBJ_YEARLY_SCHEDULES'
